<template>
  <router-link
    v-if="isLoggedIn"
    :to="{ name: homeRoute }"
    data-test="nexcess-logo-cart"
    class="logo-container"
  >
    <div class="logo-inner">
      <img :src="logoSrcAuthed" :alt="formatters.text.capitalize(company.name?.toUpperCase)" />
    </div>
  </router-link>
  <a v-else :href="SPIDEY_URL" class="logo-container">
    <div class="logo-inner">
      <img :src="logoSrcAnon" :alt="formatters.text.capitalize(company.name?.toUpperCase)" />
    </div>
  </a>
</template>

<script>
import { computed } from "vue";
import { constants } from "@/utils";
import { formatters } from "leatherman-js";
import store from "@/store";

export default {
  name: "NavLogoFull",
  setup() {
    const company = computed(() => store.getters["company/get"]);
    const homeRoute = constants.ROUTES.HOME;
    const isLoggedIn = computed(() => store.getters["auth/isLoggedIn"]);
    const SPIDEY_URL = process.env.VUE_APP_SPIDEY_URL;
    const theme = computed(() => store.getters["theme/get"]);
    const logoSrcAuthed = computed(() => {
      return {
        default: require("@/assets/nexcess-text-black.svg"),
        dark: require("@/assets/nexcess-text-white.svg"),
      }[theme.value.stylesheet];
    });
    const logoSrcAnon = computed(() => {
      return {
        default: require("@/assets/nexcess-text-byline-black.svg"),
        dark: require("@/assets/nexcess-text-byline-white.svg"),
      }[theme.value.stylesheet];
    });

    return {
      company,
      homeRoute,
      isLoggedIn,
      formatters,
      SPIDEY_URL,
      logoSrcAuthed,
      logoSrcAnon,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.logo-container {
  padding: 2px $nav-padding-side;
  margin-top: 2px;
  height: $header-cart-height;
  flex-grow: 0;
  display: flex;
  align-items: center;

  .logo-inner {
    max-height: 46px;
    max-width: 140px;
    height: 70%;

    img {
      height: 100%;
    }
  }
}
</style>
